exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cockpit-card[data-v-43b07fb2]{background-repeat:no-repeat;background-size:100% 100%;padding:var(--containerPadding)}.cockpit-card.default-card[data-v-43b07fb2]{background-image:var(--containerBgImg)}.cockpit-card.horizontal-card[data-v-43b07fb2]{background-image:var(--horizontalBgImg)}.cockpit-card.fullscreen-card[data-v-43b07fb2]{background-image:var(--fullscreenBgImg)}", ""]);

// exports
